import { Component, ComponentFactoryResolver, OnInit, ViewEncapsulation, ViewContainerRef, ViewChild, Type } from '@angular/core';

import {
  PuiAppSettings,
  PuiMenuPlacement,
  PuiMenuService, PuiAuthService
} from '../../../core/index';

import { PuiMenuProfileComponent } from '../../../ui/index';

declare var Layout: any;

@Component({
  selector: 'pui-appbar',
  styleUrls: ['./appbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'appbar.component.html'
})
export class PuiAppbarComponent implements OnInit {
  @ViewChild('pmenu', { read: ViewContainerRef }) pmenu: ViewContainerRef;

  appSettings: any;
  menuComponent: Type<any>;

  get currentUser() {
    return '';
    // let profile = this.authService.userProfile;
    // return profile ? profile.firstName + ' ' + profile.lastName : null;
  }

  constructor(private menuService: PuiMenuService,
    public authService: PuiAuthService,
    private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    // The Appbar is responsible for drawing the main App bar at the top and allowing the
    // hosting of profile and other top level menus. Once we are ready we will also integrate
    // the right slide out.
    this.appSettings = PuiAppSettings;
    this.menuComponent = this.menuService.get(PuiMenuPlacement.Profile);

    if (this.menuComponent) {
      const menuComponent = this.componentFactoryResolver.resolveComponentFactory(this.menuComponent);
      if (menuComponent.componentType.prototype instanceof PuiMenuProfileComponent) {
        setTimeout(() => {
          if (this.pmenu) {
            // at this point we want the "child" component to be rendered into the app.component:
            this.pmenu.createComponent(menuComponent);
          }
        });
      }
    }

    // Layout.init();
  }
}
